import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/store/ProductCard";

export default function FacetPage() {
  const { key } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null); setNotFound(false);
    api.get(`/facets/${key}`)
      .then((r) => {
        setPage(r.data);
        const d = r.data;
        document.title = d.meta_title || `${d.title} — Live Prices | Siyaara`;
        let meta = document.querySelector('meta[name="description"]');
        if (!meta) { meta = document.createElement("meta"); meta.name = "description"; document.head.appendChild(meta); }
        meta.content = d.meta_description || d.intro;
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
        link.href = `https://siyaara.com/jewellery/${key}`;
        // ItemList structured data for the facet grid
        document.getElementById("facet-jsonld")?.remove();
        const ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "facet-jsonld";
        ld.text = JSON.stringify({
          "@context": "https://schema.org", "@type": "ItemList",
          name: d.title,
          numberOfItems: d.count,
          itemListElement: (d.products || []).slice(0, 20).map((p, i) => ({
            "@type": "ListItem", position: i + 1,
            url: `https://siyaara.com/products/${p.slug}`, name: p.title,
          })),
        });
        document.head.appendChild(ld);
      })
      .catch(() => setNotFound(true));
    return () => document.getElementById("facet-jsonld")?.remove();
  }, [key]);

  if (notFound) {
    return (
      <div className="container-x py-20 text-center" data-testid="facet-not-found">
        <h1 className="font-heading text-2xl font-semibold">This collection isn't available right now</h1>
        <p className="text-stone-500 mt-2">We keep landing pages live only when they have enough pieces in stock.</p>
        <Link to="/shop" className="text-brand underline mt-4 inline-block" data-testid="facet-shop-link">Browse all jewellery</Link>
      </div>
    );
  }
  if (!page) return <div className="container-x py-20 text-center text-stone-400 font-mono text-sm">LOADING…</div>;

  return (
    <div className="container-x py-8" data-testid="facet-page">
      <p className="eyebrow">{page.kind?.toUpperCase()} COLLECTION</p>
      <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mt-1" data-testid="facet-h1">{page.title}</h1>
      {page.tagline && <p className="font-heading text-lg text-brand-3 italic mt-1" data-testid="facet-tagline">{page.tagline}</p>}
      <p className="text-stone-600 mt-3 max-w-3xl leading-relaxed">{page.intro}</p>
      <p className="text-xs font-mono text-stone-500 mt-2" data-testid="facet-count">{page.count} PIECES · PRICED LIVE</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {page.products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
    </div>
  );
}
